import React from "react";
import { Menu } from "lucide-react";

const MAIN_TABS = [
    { id: "main", label: "Main" },
    { id: "odds", label: "Odds" },
    { id: "outsiders", label: "Outsiders" },
];

export function TabHeader({ activeTab, setActiveTab, onOpenMoreMenu }) {
    return (
        <header className="sticky top-0 z-10 border-b border-masters-moss/40 bg-masters-forest/95 backdrop-blur-sm">
            <div className="mx-auto flex max-w-3xl items-center justify-between gap-3 px-4 py-4">
                <div className="flex min-w-0 flex-1 flex-wrap items-center justify-start gap-2">
                    {MAIN_TABS.map((tab) => (
                        <button
                            key={tab.id}
                            type="button"
                            onClick={() => setActiveTab(tab.id)}
                            className={`rounded-full px-5 py-2 text-sm font-medium transition-colors duration-200 ${
                                activeTab === tab.id
                                    ? "bg-masters-cream text-masters-forest shadow-sm ring-1 ring-masters-gold/35"
                                    : "border border-masters-moss/60 bg-masters-pine/40 text-masters-cream/80 hover:border-masters-goldmuted/40 hover:bg-masters-pine/60 hover:text-masters-cream"
                            }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
                <button
                    type="button"
                    onClick={onOpenMoreMenu}
                    className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-masters-moss/60 bg-masters-pine/40 text-masters-cream/90 transition-colors hover:border-masters-goldmuted/40 hover:bg-masters-pine/65 hover:text-masters-cream"
                    aria-label="Open menu: Leaderboard and Monies"
                >
                    <Menu className="h-5 w-5" strokeWidth={2} aria-hidden />
                </button>
            </div>
        </header>
    );
}
